import LoginService from "./LoginService";

const SharedService = {
  Check: async (context) => {
    let result = await LoginService.Check(context);
    context.setOnGoingValidations(result.data);
  },
  GenerateSlug: (input) => {
    if (!input) return "";
    return input
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-") 
      .replace(/^-+|-+$/g, "") 
      .replace(/-+/g, "-"); 
  },
};

export default SharedService;